(function () {
  if (window.skoposGallerySwipe) return;
  window.skoposGallerySwipe = true;

  function gallery(surface, image, thumbs) {
    if (surface.dataset.swipeReady || thumbs.length < 2) return;
    surface.dataset.swipeReady = 'native-scroll-v4';
    surface.style.touchAction = 'auto';
    surface.style.position = 'relative';
    surface.style.overflow = 'hidden';
    surface.tabIndex = 0;
    var urls = thumbs.map(function (thumb) { return thumb.dataset.src; });
    var index = Math.max(0, thumbs.findIndex(function (thumb) { return thumb.classList.contains('active'); }));
    var width = surface.getBoundingClientRect().width, timer = 0, frame = 0, mouse = null;
    /* 2026-09-26: the script owns the height from here on. With a CSS aspect-ratio still active, an explicit height
       makes the (auto) width follow the height, the ResizeObserver sees a wider surface, the height grows again,
       and the gallery balloons to several screen heights between the 8:5 and 1:1 slides. */
    surface.style.aspectRatio = 'auto';
    var touching = false, command = null, destroyed = false;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobile = window.matchMedia('(max-width: 768px)');
    function ratioFor(n) { return mobile.matches && n < 2 ? 5 / 8 : 1; }
    var imageStyle = getComputedStyle(image);
    var listeners = new AbortController();
    var viewport = document.createElement('div');
    viewport.className = 'sk-gallery-scroll';
    viewport.setAttribute('aria-hidden', 'true');
    viewport.style.cssText = 'position:absolute;top:0;left:0;width:100%;display:flex;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x mandatory;scrollbar-width:none;overscroll-behavior-x:contain;touch-action:auto;-webkit-overflow-scrolling:touch;direction:ltr;z-index:1';
    viewport.style.height = width + 'px';
    var style = document.createElement('style');
    style.textContent = '.sk-gallery-scroll::-webkit-scrollbar{display:none}.sk-gallery-scroll img{-webkit-user-drag:none;user-select:none}';
    surface.appendChild(style);
    var physical = [urls.length - 1].concat(urls.map(function (_, n) { return n; }), [0]);
    var slides = physical.map(function (n, slot) {
      var slide = document.createElement('span');
      slide.style.cssText = 'position:relative;display:block;flex:0 0 100%;width:100%;height:100%;min-width:0;scroll-snap-align:start;scroll-snap-stop:always';
      var pic = document.createElement('img');
      pic.alt = '';
      pic.draggable = false;
      pic.loading = Math.abs(slot - (index + 1)) <= 1 ? 'eager' : 'lazy';
      pic.decoding = 'async';
      pic.src = urls[n];
      pic.style.cssText = 'display:block!important;width:100%!important;height:100%!important;max-width:none!important;max-height:none!important;margin:0!important;pointer-events:none;transform:translateY(var(--sk-gallery-offset,0px));';
      pic.style.setProperty('object-fit', imageStyle.objectFit, 'important');
      pic.style.setProperty('object-position', imageStyle.objectPosition, 'important');
      slide.appendChild(pic);
      viewport.appendChild(slide);
      return pic;
    });
    surface.appendChild(viewport);
    image.style.opacity = '0';
    var dots = document.createElement('span');
    dots.className = 'sk-gallery-indicators';
    dots.setAttribute('aria-hidden', 'true');
    dots.style.cssText = 'position:absolute;bottom:12px;left:50%;transform:translateX(-50%);display:flex;align-items:center;gap:5px;padding:7px 9px;border-radius:20px;background:rgba(255,255,255,.88);pointer-events:none;z-index:4';
    urls.forEach(function () {
      var dot = document.createElement('span');
      dot.style.cssText = 'display:block;height:5px;width:5px;border-radius:5px;background:#c7c3bb';
      dots.appendChild(dot);
    });
    surface.appendChild(dots);
    function wrap(n) { return (n + urls.length) % urls.length; }
    function setHeight() {
      if (!width) return;
      var pos = Math.max(0, Math.min(physical.length - 1, viewport.scrollLeft / width));
      var a = Math.floor(pos), b = Math.min(a + 1, physical.length - 1), f = pos - a;
      var blend = f * f * (3 - 2 * f);
      var h = width * (ratioFor(physical[a]) * (1 - blend) + ratioFor(physical[b]) * blend);
      surface.style.height = h + 'px';
      viewport.style.setProperty('--sk-gallery-offset', (h - width) / 2 + 'px');
    }
    function mark(n) {
      var next = wrap(n);
      if (surface.dataset.galleryIndex === String(next)) return;
      index = next;
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('active', i === index);
        thumb.setAttribute('aria-pressed', String(i === index));
        dots.children[i].style.width = i === index ? '16px' : '5px';
        dots.children[i].style.background = i === index ? '#FF7449' : '#c7c3bb';
      });
      surface.dataset.galleryIndex = String(index);
      surface.classList.toggle('photo', thumbs[index].dataset.type === 'photo');
      if (image.getAttribute('src') !== urls[index]) image.src = urls[index];
      [index, index + 1, index + 2].forEach(function (slot) {
        if (slides[slot]) slides[slot].loading = 'eager';
      });
    }
    function sync() {
      frame = 0;
      if (destroyed) return;
      var measured = surface.getBoundingClientRect().width;
      if (measured && measured !== width) {
        width = measured;
        viewport.style.height = width + 'px';
        viewport.scrollTo({left: (index + 1) * width, behavior: 'auto'});
      }
      setHeight();
      if (width) mark(Math.round(viewport.scrollLeft / width) - 1);
    }
    function settled() {
      clearTimeout(timer);
      if (destroyed || touching || mouse || !width) return;
      sync();
      var slot = Math.round(viewport.scrollLeft / width);
      if (slot === 0 || slot === urls.length + 1) {
        viewport.scrollTo({ left: (index + 1) * width, behavior: 'auto' });
      }
      viewport.style.scrollSnapType = 'x mandatory';
      command = null;
    }
    function go(n, smooth, slot) {
      command = wrap(n);
      viewport.style.scrollSnapType = 'none';
      viewport.scrollTo({left: (slot === undefined ? command + 1 : slot) * width, behavior: smooth && !reduced.matches ? 'smooth' : 'auto'});
      if (!smooth || reduced.matches) sync();
    }
    viewport.addEventListener('scroll', function () {
      if (!frame) frame = requestAnimationFrame(sync);
      clearTimeout(timer);
      timer = setTimeout(settled, 180);
    }, {passive:true});
    viewport.addEventListener('scrollend', settled, {passive:true});
    viewport.addEventListener('pointerdown', function (event) {
      command = null;
      if (event.pointerType !== 'mouse') { touching = true; return; }
      if (event.button !== 0) return;
      mouse = {id:event.pointerId, x:event.clientX, left:viewport.scrollLeft, moved:false};
      viewport.style.scrollSnapType = 'none';
      viewport.setPointerCapture(event.pointerId);
    }, {passive:true});
    viewport.addEventListener('pointermove', function (event) {
      if (!mouse || event.pointerId !== mouse.id) return;
      var dx = event.clientX - mouse.x;
      if (Math.abs(dx) > 3) mouse.moved = true;
      viewport.scrollLeft = mouse.left - dx;
      setHeight();
      if (mouse.moved) event.preventDefault();
    });
    function release(event) {
      if (event.pointerType !== 'mouse') {
        touching = false;
        clearTimeout(timer);
        timer = setTimeout(settled, 180);
        return;
      }
      if (!mouse || event.pointerId !== mouse.id) return;
      var gesture = mouse;
      mouse = null;
      if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      var delta = viewport.scrollLeft - gesture.left;
      var slot = Math.round(viewport.scrollLeft / width);
      if (gesture.moved && Math.abs(delta) > 24) slot = Math.round(gesture.left / width) + (delta > 0 ? 1 : -1);
      slot = Math.max(0, Math.min(urls.length + 1, slot));
      go(slot - 1, true, slot);
    }
    viewport.addEventListener('pointerup', release, {passive:true});
    viewport.addEventListener('pointercancel', release, {passive:true});
    viewport.addEventListener('lostpointercapture', release, {passive:true});
    viewport.addEventListener('dragstart', function (event) { event.preventDefault(); });
    surface.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
      if (event.target.closest('button,a,input,select,textarea')) return;
      event.preventDefault();
      var current = command === null ? index : command;
      var step = event.key === 'ArrowRight' ? 1 : -1;
      var target = current + step;
      go(target, true, target < 0 ? 0 : target === urls.length ? urls.length + 1 : undefined);
    }, {signal:listeners.signal});
    thumbs.forEach(function (thumb, n) {
      thumb.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        go(n, false);
      }, {capture:true, signal:listeners.signal});
    });
    var observer = new ResizeObserver(function () {
      var nextWidth = surface.getBoundingClientRect().width;
      if (nextWidth && nextWidth !== width) {
        width = nextWidth;
        viewport.style.height = width + 'px';
        mouse = null;
        viewport.style.scrollSnapType = 'x mandatory';
        go(index, false);
        setHeight();
      }
    });
    observer.observe(surface);
    mobile.addEventListener('change', setHeight);
    surface.skoposGalleryDestroy = function () {
      destroyed = true;
      clearTimeout(timer);
      cancelAnimationFrame(frame);
      observer.disconnect();
      listeners.abort();
      mobile.removeEventListener('change', setHeight);
      /* 2026-09-26: full teardown so the gallery can be rebuilt for another finish */
      viewport.remove(); dots.remove(); style.remove();
      delete surface.dataset.swipeReady; delete surface.dataset.galleryIndex;
      surface.style.height = ''; surface.style.aspectRatio = ''; image.style.opacity = '';
    };
    mark(index);
    viewport.scrollLeft = (index + 1) * width;
    setHeight();
  }
  function init() {
    var main = document.getElementById('gmain'), image = document.getElementById('mainimg');
    var parent = main && main.closest('.gallery');
    var thumbs = parent && Array.from(parent.querySelectorAll('.thumbs button[data-src]'));
    if (main && image && thumbs) gallery(main, image, thumbs);
  }
  window.SkoposGallery = { init: init, rebuild: function () {
    var main = document.getElementById('gmain');
    if (main && main.skoposGalleryDestroy) main.skoposGalleryDestroy();
    init();
  } };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    var main = event.target.querySelector('#gmain');
    if (main && main.skoposGalleryDestroy) main.skoposGalleryDestroy();
  });
})();
/* build 2026-09-26T20:30 aspect-ratio fix */
